import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareLevelPropertiesData } from './share-level-properties-data.interface'; 
import { FileService } from 'app/services/file.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';


@Component({
  standalone: true,
  selector: 'app-share-level-properties-dialog',
  templateUrl: './share-level-properties-dialog.component.html',
  styleUrls: ['./share-level-properties-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    TranslocoModule
  ]
})
export class ShareLevelPropertiesDialogComponent {

  editOptions = [
    { value: 'PRV', text: 'modal.shareLevel.prv' },
    { value: 'DOM', text: 'modal.shareLevel.dom' },
    { value: 'PUB', text: 'modal.shareLevel.pub' }
  ];

  shareLevelOptions = [
    { value: 'PRV', text: 'modal.shareLevel.prv' },
    { value: 'DOM', text: 'modal.shareLevel.dom' },
    { value: 'PUB', text: 'modal.shareLevel.pub' }
  ];

  constructor(
    public dialogRef: MatDialogRef<ShareLevelPropertiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareLevelPropertiesData,
    private fileService: FileService
  ) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  get filteredEditOptions() {
    if (this.data.shareLevel === 'PRV') {
      return this.editOptions.filter(o => o.value === 'PRV');
    } else if (this.data.shareLevel === 'DOM') {
      return this.editOptions.filter(o => o.value !== 'PUB'); 
    } else {
      // PUB => tutte
      return this.editOptions;
    }
  }
  

  onConfirm(): void {
    if (this.data.isFolder) {
      this.fileService.updateFolderShareLevel(this.data.itemId, this.data.shareLevel).subscribe(
        () => {
          this.fileService.updateFolderShareLevel(this.data.itemId, this.data.shareLevelEdit, true).subscribe(
            () => {
              this.dialogRef.close({
                shareLevel: this.data.shareLevel,
                shareLevelEdit: this.data.shareLevelEdit
              });
            },
            (err) => {
              console.error('Errore updateFolderShareLevelEdit:', err);
              this.dialogRef.close(null);
            }
          );
        },
        (error) => {
          console.error('Errore updateFolderShareLevel:', error);
          this.dialogRef.close(null);
        }
      );
    } else {
      this.fileService.updateShareLevel(this.data.itemId, this.data.shareLevel, this.data.isExternal).subscribe(
        () => {
          this.fileService.updateShareLevel(this.data.itemId, this.data.shareLevelEdit, this.data.isExternal, true).subscribe(
            () => {
              this.dialogRef.close({
                shareLevel: this.data.shareLevel,
                shareLevelEdit: this.data.shareLevelEdit
              });
            },
            (err) => {
              console.error('Errore updateShareLevelEdit:', err);
              this.dialogRef.close(null);
            }
          );
        },
        (error) => {
          console.error('Errore updateShareLevel:', error);
          this.dialogRef.close(null);
        }
      );
    }
  }
}
